module.exports = __webpack_public_path__ + "media/images/flags/32/Botswana-e0440d7500c33e571c025bf1b403fc1e.png";